(function(angular) {
    'use strict';

    // reCAPTCHA v3 – invisible, score-based
    var RECAPTCHA_SITE_KEY = '6Ld5oY0UAAAAAM7fcbcojIfa5MhW7BqPgBsuDje2';

    angular.module('spCaptcha', [])
    .service('SpCaptcha', ['$q', function($q) {
        var self = this;

        self.getToken = getToken;

        /**
         * Get reCAPTCHA v3 token (async).
         * @param {string} action - e.g. 'login', 'register', 'forgot_password', 'submit'
         * @returns {Promise<string>} - resolves with token to send as recaptchaHash
         */
        function getToken(action) {
            action = action || 'submit';
            if (!window.grecaptcha || !window.grecaptcha.execute) {
                return $q.reject(new Error('reCAPTCHA v3 not loaded'));
            }
            return $q(function(resolve, reject) {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: action })
                        .then(resolve)
                        .catch(reject);
                });
            });
        }
    }])
    .directive('spCaptcha', [function() {
        return {
            restrict: 'E',
            replace: false,
            template: '<div class="captcha-holder captcha-v3-placeholder"></div>',
            scope: {
                isInvalid: '=?'
            },
            link: function($scope, element) {
                var outerElement = element[0];
                insertV3ScriptOnce();

                function insertV3ScriptOnce() {
                    if (window.spCaptchaV3Inserted) return;
                    window.spCaptchaV3Inserted = true;
                    var script = document.createElement('script');
                    script.async = true;
                    script.defer = true;
                    script.type = 'text/javascript';
                    script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(RECAPTCHA_SITE_KEY);
                    var first = document.getElementsByTagName('script')[0];
                    first.parentNode.insertBefore(script, first);
                }

                $scope.$watch('isInvalid', function(value) {
                    if (value) {
                        outerElement.classList.add('captcha-error');
                    } else {
                        outerElement.classList.remove('captcha-error');
                    }
                });
            }
        };
    }]);
})(angular);
